var map = {
	"./aboutinfo.svg": "f48d",
	"./add.svg": "58n+",
	"./aicenter.svg": "t9xR",
	"./article.svg": "TLrK",
	"./battery.svg": "WLkG",
	"./chaocai.svg": "8j78",
	"./datacenter.svg": "eM+U",
	"./datalist.svg": "boM3",
	"./del.svg": "CWZL",
	"./example.svg": "OOLB",
	"./eye.svg": "4wdf",
	"./form.svg": "sTIr",
	"./health.svg": "bVfG",
	"./home.svg": "U9Ws",
	"./jianguo.svg": "Ymmd",
	"./jiaozi.svg": "+rFr",
	"./login-mall.svg": "xzZT",
	"./marker.svg": "0+/s",
	"./miandian.svg": "kM/9",
	"./miantiao.svg": "mhIy",
	"./notice.svg": "MqGM",
	"./oms.svg": "zblz",
	"./password.svg": "QjmH",
	"./phoneclose.svg": "Yqm0",
	"./picedit.svg": "G9G0",
	"./piclist.svg": "Q/Gu",
	"./picview.svg": "ZD7a",
	"./pms.svg": "D2LQ",
	"./rujiang.svg": "d3aR",
	"./setting.svg": "Kttn",
	"./shuiguo.svg": "6ex6",
	"./singnal.svg": "KvRz",
	"./sms.svg": "AS+9",
	"./tanggeng.svg": "oKcM",
	"./tangshui.svg": "eJbH",
	"./ums-admin.svg": "FR/6",
	"./ums-menu.svg": "sr5k",
	"./ums-resource.svg": "noU8",
	"./ums-role.svg": "w7oB",
	"./ums.svg": "J4x9",
	"./upload.svg": "P/TB",
	"./user.svg": "VdD3",
	"./wifi.svg": "cNBo",
	"./xiaocai.svg": "0+SU",
	"./yyjc.svg": "INL1",
	"./zhengzhu.svg": "M7mF",
	"./zhou.svg": "VIAB",
	"./zhushi.svg": "1ERA",
	"./zhushui.svg": "uYYc"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 22